import { ReactNode } from 'react';

export class PoolTableRowValue {
    public constructor(public content: ReactNode | string, public colSpan?: number, public rowSpan?: number) {}
}
